var React = require('react');

function ContentCamp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m51.52,48L27.72,6.8l2.6-4.5c.4-.7.2-1.7-.6-2.1C29.02-.2,28.02,0,27.63.8l-1.7,3-1.7-3c-.4-.7-1.4-1-2.1-.6-.7.4-1,1.4-.6,2.1l2.6,4.5-1.5,2.6L.53,47.5c-.1.1-.1.3-.2.5l-.1.2c-.3.5-.3,1.1,0,1.5.3.5.8.8,1.3.8h48.7c.8,0,1.5-.7,1.5-1.5.1-.4,0-.7-.2-1Zm-17.1-4.3l-4.7-4.7h4.7v4.7Zm-.7,3.7h-15.5l7.8-7.8,7.7,7.8Zm-16.2-3.7v-4.7h4.7l-4.7,4.7Zm6.9-31.2v23.5h-8.4c-.8,0-1.5.7-1.5,1.5v9.9H4.22L24.43,12.5Zm13.1,34.9v-9.9c0-.8-.7-1.5-1.5-1.5h-8.5V12.5l20.1,34.9h-10.1Z"}));
}

ContentCamp.defaultProps = {"role":"presentation","id":"uuid-9c1effcc-2ea8-4461-a9e1-3cfd62099d03","data-name":"Layer 1","viewBox":"0 0 51.76 50.5"};

module.exports = ContentCamp;

ContentCamp.default = ContentCamp;
